/**
 * User-identity comparison for the messaging surfaces.
 *
 * Why this exists: the two ids being compared arrive in different types.
 *
 *   - Ids from GraphQL are the `ID` scalar, which serializes to a STRING ("4512").
 *   - `currentUser` comes from Rails props — succession_controller.rb's
 *     `current_user.as_json(only: [:id, ...])` — so its id is a NUMBER (4512).
 *
 * A bare `===` between them is therefore always false, and the failure is silent:
 * the code takes the "not me" branch for every conversation and every message.
 * That shipped as the conversation-tile preview labelling your own messages with
 * the other participant's name, and as blocked_by_me/blocked_by_them being
 * swapped for anyone who was participant_1.
 *
 * The inline `String(a) === String(b)` idiom was already used correctly in some
 * places and missed in others *within the same file*, which is why this is a
 * named helper rather than a seventh copy.
 *
 * @param {string|number|null|undefined} a
 * @param {string|number|null|undefined} b
 * @returns {boolean} true when both ids are present and refer to the same user
 */
export function isSameUser(a, b) {
  // Guard explicitly: String(undefined) === String(undefined) is true, which
  // would make two absent users "the same" and re-introduce the bug inverted.
  if (a === null || a === undefined || b === null || b === undefined) return false;

  return String(a) === String(b);
}

export default isSameUser;
